import { dateFormatMap, dateTypeMap } from '@op/constants';
import { formatTime } from '../../render-helper';
import { mentionsSentimentRenderHelperFuncMap } from '@op/pages/Overview/CompareKeyMetrics/constants';

export default function (params: any) {
  let { by_type, tab_type, date_type, sub_type } = params || {};
  const formatFunc =
    mentionsSentimentRenderHelperFuncMap?.[sub_type || by_type || tab_type] ||
    {};
  const valueColumns: { [key: string]: string } = {
    mentions: 'Mentions',
    brand_health: 'Brand Health',
    sentiment: 'Sentiment',
    all_reviews: 'All Reviews',
    recent_reviews: 'Recent Reviews',
    select_all_review: 'Added Reviews',
    lifetime: 'Lifetime Rating',
    selected: 'Added Reviews',
    pr: 'PR',
    google_trends: 'Google Trends',
    impressions: 'Potential Impressions',
    publications: 'Publications',
    creators: 'Number of Creators',
    views: 'Views',
    engagement: 'Engagement',
    hours_watched: 'Hours Watched',
    streamers: 'Streamers',
    peak_ccv: 'Peak CCV',
    acg_ccv: 'Avg CCV',
    engagement_rate: 'Engagement Rate',
    followers: 'Followers',
    lifetime_rating: 'Lifetime Rating',
    lifetime_positive: 'Positive%',
    lifetime_negative: 'Negative%',
    select_avg_rating: 'Average Rating',
    select_positive_mentions: 'Positive%',
    select_negative_mentions: 'Negative%',
    all_reviews_positive: 'Positive%',
    all_reviews_negative: 'Negative%',
    recent_reviews_positive: 'Positive%',
    recent_reviews_negative: 'Negative%',
    added_reviews_positive: 'Positive%',
    added_reviews_negative: 'Negative%',
    official_account_followers: 'Followers',
  };

  return [
    {
      header: 'Date',
      render: 'time',
      renderHelper: [formatTime(dateFormatMap[dateTypeMap[date_type]])],
    },
    {
      header: 'Game',
      render: 'name',
    },
    {
      header: valueColumns?.[sub_type || by_type || tab_type],
      render: 'value',
      ...formatFunc,
    },
  ];
}
